import { useLocation, useNavigate } from "react-router-dom";
import { MODULES, MODULE_GROUPS } from "@shared/modules.ts";
import { Icon } from "../../lib/icons.tsx";

export function Sidebar({ open, onClose }: { open: boolean; onClose: () => void }) {
  const loc = useLocation();
  const nav = useNavigate();

  const go = (path: string) => {
    nav(path);
    onClose();
  };

  return (
    <aside className={"sidebar" + (open ? " sidebar--open" : "")}>
      <div className="sidebar__brand">
        <div className="sidebar__logo">MH</div>
        <div className="sidebar__title">
          MARKETING Hero
          <small>Sooksabay AI Advisor</small>
        </div>
      </div>

      {MODULE_GROUPS.map((group) => {
        const items = MODULES.filter((m) => m.group === group);
        if (!items.length) return null;
        return (
          <div className="sidebar__group" key={group}>
            <div className="sidebar__group-label">{group}</div>
            {items.map((m) => {
              const active = m.path === "/" ? loc.pathname === "/" : loc.pathname.startsWith(m.path);
              return (
                <div
                  key={m.id}
                  className={"nav-item" + (active ? " nav-item--active" : "")}
                  onClick={() => go(m.path)}
                  title={m.desc}
                >
                  <span className="nav-item__icon"><Icon name={m.icon} size={18} /></span>
                  <span className="nav-item__label">{m.label}</span>
                  {m.status === "building" && <span className="nav-item__dot" title="กำลังพัฒนา (milestone ถัดไป)" />}
                </div>
              );
            })}
          </div>
        );
      })}

      <div className="sidebar__foot">v0.1 · Milestone 1<br />ยังไม่เชื่อม Ads API (ตามแผน V1)</div>
    </aside>
  );
}
